import React from 'react';
import { Store, DoorOpen, Building, LayoutGrid, Building2, HardHat, Maximize, Wrench } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Store className="w-8 h-8 text-primary-600" data-id="element-315" />,
    title: 'Storefront Glass Replacement & Repair',
    copy: 'Commercial storefront glass repair, replacement storefront systems, retail windows, display glass and storefront entrances built for visibility, safety and durability.'
  }, {
    icon: <DoorOpen className="w-8 h-8 text-primary-600" data-id="element-316" />,
    title: 'Commercial Door Glass & Entry Systems',
    copy: 'Commercial door glass replacement, entry door glass, sidelights, entrance systems and door glass parts repair or replacement.'
  }, {
    icon: <Building className="w-8 h-8 text-primary-600" data-id="element-317" />,
    title: 'Commercial Windows & Business Window Replacement',
    copy: 'Business window replacement, commercial windows, insulated glass units, preglazed window systems and ribbon windows for offices, retail and commercial properties.'
  }, {
    icon: <LayoutGrid className="w-8 h-8 text-primary-600" data-id="element-318" />,
    title: 'Office Glass Walls & Dividers',
    copy: 'Office glass wall installation, full-height glass walls, half office walls, dividers, conference rooms, partitions and privacy glass options.'
  }, {
    icon: <Building2 className="w-8 h-8 text-primary-600" data-id="element-319" />,
    title: 'Curtain Walls & Exterior Glazing',
    copy: 'Aluminum curtain walls, exterior glass walls, slope glazing, commercial entrances, lobbies and complete exterior glazing systems.'
  }, {
    icon: <HardHat className="w-8 h-8 text-primary-600" data-id="element-320" />,
    title: 'Contract Glazing & New Construction',
    copy: 'Commercial glazing for builders, contractors and owners, including design support, field measurement, fabrication, installation and project coordination.'
  }, {
    icon: <Maximize className="w-8 h-8 text-primary-600" data-id="element-321" />,
    title: 'Interior Glass, Pass-Throughs & Mirror Systems',
    copy: 'Interior glass systems, countertop sliding systems, pass-through windows for security and privacy, commercial mirror systems and specialty interior glazing.'
  }, {
    icon: <Wrench className="w-8 h-8 text-primary-600" data-id="element-322" />,
    title: 'Service & Maintenance for Existing Buildings',
    copy: 'Repair, replacement, system maintenance and commercial glass service for existing storefronts, offices, retail buildings and commercial properties.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-323">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-325">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-326">
            Commercial Glass Services for Businesses, Builders & Property
            Managers
          </h2>
          <p className="text-lg text-slate-600" data-id="element-327">
            From storefront glass repair to full commercial glazing projects,
            Kosin’s Glass designs, fabricates, replaces, repairs and installs
            commercial glass for new and existing buildings.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-328">
          {services.map((service, idx) => <div key={idx} className="bg-white rounded-md p-6 border border-neutral-200 shadow-sm hover:shadow-md transition-shadow group" data-id="element-329">
              <div className="w-14 h-14 bg-primary-50 rounded-md flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-330">
                {service.icon}
              </div>
              <h3 className="kosins-heading text-2xl text-neutral-900 mb-3 leading-tight" data-id="element-331">
                {service.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-332">
                {service.copy}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-333">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3.5 px-8 rounded-md transition-colors uppercase tracking-wider text-sm" data-id="element-334">
            Request a Free Commercial Estimate
          </button>
        </div>
      </div>
    </section>;
}